import { useState } from "react";
import axios from 'axios';

import Header from "../components/Header/Header";

const Support = () => {
    const [inputs, setInputs] = useState({
        name: '',
        whatsapp: '',
        unit: 'Clínica do esporte - Sul',
        requestType: 'Gesthor',
        description: '',
        anyDeskId: '',
        standardProcedures: 'Não',
        technician: '556232390125',
        section: ''
    });

    const [isLoading, setIsLoading] = useState(false);

    function handleSetInputValue(identifier, value) {
        setInputs((curInputs) => {
            return {
                ...curInputs,
                [identifier]: value
            };
        });
    }

    const handleSendMessage = (event) => {
        event.preventDefault();

        const message = `
            *Chamado Clínica do Esporte*\n\n` +
            `*Nome:* ${inputs.name}\n` +
            `*WhatsApp:* ${inputs.whatsapp}\n` +
            `*Unidade:* ${inputs.unit}\n` +
            `*Tipo de solicitação:* ${inputs.requestType}\n` +
            `*Descrição:* ${inputs.description}\n` +
            `*ID AnyDesk:* ${inputs.anyDeskId}\n` +
            `*Procedimentos padrões realizados:* ${inputs.standardProcedures}\n` +
            `*Setor:* ${inputs.section}\n`;

        if (inputs.technician === 'email') {
            sendEmail();
            return;
        }

        const url = `https://api.whatsapp.com/send?phone=${inputs.technician}&text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    }

    const sendEmail = async () => {
        setIsLoading(true);
        const message = `
            Chamado Clínica do Esporte\n\n` +
            `Nome: ${inputs.name}\n` +
            `WhatsApp: ${inputs.whatsapp}\n` +
            `Unidade: ${inputs.unit}\n` +
            `Tipo de solicitação: ${inputs.requestType}\n` +
            `Descrição: ${inputs.description}\n` +
            `ID AnyDesk: ${inputs.anyDeskId}\n` +
            `Procedimentos padrões realizados: ${inputs.standardProcedures}\n` +
            `Setor: ${inputs.section}\n`;

        try {
            await axios.post(`https://formspree.io/f/mwvjzodk`, {
                message: message
            });

            alert('Solicitação enviada com sucesso!');

            setInputs({
                name: '',
                whatsapp: '',
                unit: 'Clínica do Esporte - Sul',
                requestType: 'Gesthor',
                description: '',
                anyDeskId: '',
                standardProcedures: 'Não',
                technician: '556232390125',
                section: ''
            });
        } catch (error) {
            alert('Erro ao enviar solicitação.');
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <Header />
            <div style={{ marginBottom: '2em' }}>
                <div className="container">
                    <h1 className="text-center text-primary">Chamados Clínica do Esporte</h1>
                    <form onSubmit={handleSendMessage}>
                        <div className="form-group">
                            <label>Nome <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.name} onChange={(e) => handleSetInputValue('name', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>WhatsApp <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.whatsapp} onChange={(e) => handleSetInputValue('whatsapp', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Selecione a unidade <span className="text-danger">*</span></label>
                            <select className="form-control" required value={inputs.unit} onChange={(e) => handleSetInputValue('unit', e.target.value)}>
                                <option value="Clínica do esporte - Sul">Clínica do esporte - Sul</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Qual sua solicitação <span className="text-danger">*</span></label>
                            <select className="form-control" required value={inputs.requestType} onChange={(e) => handleSetInputValue('requestType', e.target.value)}>
                                <option value="Gesthor">Gesthor</option>
                                <option value="ANIMATI/WTT">ANIMATI/WTT</option>
                                <option value="Computador (CPU)">Computador (CPU)</option>
                                <option value="Monitor">Monitor</option>
                                <option value="Estabilizador">Estabilizador</option>
                                <option value="Impressora">Impressora</option>
                                <option value="Perifericos (mouse, teclado, leitor, etc)">Perifericos (mouse, teclado, leitor, etc)</option>
                                <option value="Internet">Internet</option>
                                <option value="Outros">Outros</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Setor <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.section} onChange={(e) => handleSetInputValue('section', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Descreva sua solicitação (rica em detalhes) <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.description} onChange={(e) => handleSetInputValue('description', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Qual seu ID AnyDesk (Conectar ao PC) <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.anyDeskId} onChange={(e) => handleSetInputValue('anyDeskId', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Chamados via <span className="text-danger">*</span></label>
                            <select className="form-control" required value={inputs.technician} onChange={(e) => handleSetInputValue('technician', e.target.value)}>
                                <option value="556232390125">Whats. Lucas</option>
                                <option value="556230914380">Whats.Mateus</option>
                                <option value="556232390124">Whats. André</option>
                            </select>
                        </div>
                        <button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '8px' }}></span>
                                    Enviando...
                                </>
                            ) : (
                                'Enviar'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Support;